export default "__VITE_ASSET__Ck9dy$jA__"